import React from "react";
import styles from "./NoteTags.module.scss";

export default function NoteStatus({status}) {

  let color = "#ffffff";
  let backgroundColor = "#000000";
  let title = "";

  switch(status) {
    case "open":
      title = "Open";
      backgroundColor = "#ff7e00";
      break;

    case "resolved":
      title = "Resolved";
      backgroundColor = "#00bc34";
      break;

    default: 
      title = status;
  }

  let style = {
    color: color,
    backgroundColor: backgroundColor
  }

  return (
    <div className={styles.tag} key={status} title={title} style={style}>{title}</div>
  )

}